import React from 'react';
import { gql } from '@soundxyz/gql-string';
import type { PostLinkSource } from '@soundxyz/utils/analytics';
import { AccessibleLink } from '@components/main-components/link/AccessibleLink';
import {
  type FragmentType,
  getFragment,
  ListReleaseCreatedPostFragmentDoc,
  type UserInfoCreatedPostFragmentDoc,
} from '@graphql/reactQuery';
import { SPACE } from '@utils/constants';
import { webappUriPath } from '@utils/url';
import { ReleasePill } from '../../components/ReleasePill';
import { UserInfoCreatedPost } from './UserInfoCreatedPost';

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment ListReleaseCreatedPost on ReleasePost {
    id
    release {
      title
      webappUri
      ...ReleasePill
    }
  }
`);

export const ReleaseCreatedPost = ({
  userInfoFrag,
  releasePostFrag,
  postLinkSource,
  hideArtistOnPill,
}: {
  userInfoFrag: FragmentType<UserInfoCreatedPostFragmentDoc>;
  releasePostFrag: FragmentType<ListReleaseCreatedPostFragmentDoc>;
  postLinkSource: PostLinkSource;
  hideArtistOnPill: boolean;
}) => {
  const postData = getFragment(ListReleaseCreatedPostFragmentDoc, releasePostFrag);

  if (!postData.release) return null;
  return (
    <UserInfoCreatedPost
      profileCreatedPostFrag={userInfoFrag}
      postLinkSource={postLinkSource}
      postContent={
        <div className="inline-flex">
          <div className="mx-1 hidden lg:block">
            <ReleasePill release={postData.release} hideArtist={hideArtistOnPill} />
          </div>
          <AccessibleLink
            pathnameUri={webappUriPath(postData.release.webappUri)}
            className="max-w-[200px] overflow-hidden text-ellipsis whitespace-nowrap font-semibold text-base800 md:max-w-[300px] lg:hidden"
          >
            <span>{postData.release.title}</span>
          </AccessibleLink>
          {SPACE}
        </div>
      }
    />
  );
};
